var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"max-width":"95vw","height":"95vh","display":"flex","justify-content":"center","align-items":"center"}},[_c('img',{staticStyle:{"max-width":"100%","max-height":"100%","object-fit":"cover"},attrs:{"src":_vm.url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }